
const values = [
  {
    icon: 'ri-leaf-line',
    title: 'Pure Ingredients',
    description:
      'We source only the finest natural botanicals from ethical farms worldwide. No synthetics, no shortcuts — just nature at its most exquisite.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Artisan Craftsmanship',
    description:
      'Every product is hand-blended by our master perfumers, each with decades of experience in the delicate art of fragrance composition.',
  },
  {
    icon: 'ri-earth-line',
    title: 'Sustainable Luxury',
    description:
      'From recyclable packaging to carbon-neutral shipping, we believe true luxury should never come at the planet\u2019s expense.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Cruelty Free',
    description:
      'We are proudly certified cruelty-free and vegan. Our commitment to compassion extends to every living being.',
  },
  {
    icon: 'ri-sparkling-line',
    title: 'Timeless Quality',
    description:
      'We don\u2019t chase trends. Our formulations are designed to be timeless — scents and oils you\u2019ll reach for year after year.',
  },
  {
    icon: 'ri-heart-3-line',
    title: 'Community First',
    description:
      'We reinvest in the farming communities that supply our ingredients, supporting education and sustainable agriculture programs.',
  },
];

export default function BrandValues() {
  return (
    <section className="py-24 bg-[#F1F8E9]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#2E7D32] text-sm tracking-[0.2em] mb-3 font-medium">
            WHAT WE STAND FOR
          </p>
          <h2 className="text-4xl font-serif text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-gray-500 text-[15px] max-w-xl mx-auto leading-relaxed">
            Every decision we make is guided by these principles — from the ingredients we choose 
            to the way we package and deliver our products.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {values.map((value) => (
            <div
              key={value.title}
              className="bg-white rounded-xl p-8 hover:shadow-lg transition-shadow duration-300 group"
            >
              <div className="w-14 h-14 rounded-xl bg-[#E8F5E9] flex items-center justify-center mb-5 group-hover:bg-[#2E7D32] transition-colors duration-300">
                <i
                  className={`${value.icon} text-2xl text-[#2E7D32] group-hover:text-white transition-colors duration-300`}
                ></i>
              </div>
              <h3 className="text-lg font-serif text-gray-900 mb-3">{value.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
